<template>
  <div class="animated fadeIn">
    <Forms ref="frmGroup"
      :title="'CADASTRO DE CLUSTERIZAÇÃO'"
      :showClearButton="true"
      :showSaveButton="true"
      :showBackButton="true"
      v-on:Clear="onClear"
      v-on:Back="onBack"
      v-on:Save="onSave">
      <div class="form-group row">
        <div class="col-md-12">
          <label ><small v-show="form.descricao.required" class="text-danger">*</small> Clusterização:</label>
          <div class="input-group">
            <b-form-input type="text"
                          :placeholder="'Digite o nome da Clusterização'"
                          v-model="form.descricao.value"
                          :size="form.descricao.maxlength"
                          :required="form.descricao.required"
                          :state="form.descricao.state"></b-form-input>
          </div>
        </div>
      </div>
    </Forms>
  </div>
</template>
<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import { toast, loading } from '@/shared/utils/UIHelper'
import Tools from '@/components/tools/Tools.js'

import ClusterModel from '@/shared/models/configurations/clustermodel.js'
import ClusterForms from './clusteradd-form.js'
import ClusterRepository from '@/shared/http/repositories/configurations/cluster.js'

export default {
  name: 'ClusterAdd',
  mixins: [ActionsForm],
  data () {
    return {
      data: ClusterModel,
      form: ClusterForms
    }
  },
  methods: {
    onBack () {
      this.$emit('Back')
    },
    onLoad () {
    },
    onEdit (obj) {
      loading.push()
      Tools.SetValueInForm(this.form, this.data, obj)
      loading.pop()
    },
    onCreate () {
      loading.push()
      ClusterRepository.Create(this.data)
        .then((response) => {
          loading.close()
          this.$emit('Back')
          toast.success(this.$lang.Common.Alerts.Success)
        })
        .catch(this.onException)
    },
    onUpdate () {
      loading.push()
      this.data.id = parseInt(this.data.id)
      ClusterRepository.Update(this.data)
        .then((response) => {
          loading.close()
          this.$emit('Back')
          toast.success(this.$lang.Common.Alerts.Success)
        })
        .catch(this.onException)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/configurations/clusters/components/add/clusteradd.vue